import { motion } from "framer-motion";
import React from "react";

export const MagicLoader = () => {
  return (
    <div className="relative w-full h-32 flex items-center justify-center bg-gradient-to-br from-sky-50 to-sky-100 rounded-lg overflow-hidden">
      <p className="text-gray-600 font-semibold">Loading Posts...</p>

      {/* Sparkling Dots */}
      {Array.from({ length: 12 }).map((_, i) => (
        <motion.div
          key={i}
          className="absolute w-2 h-2 bg-sky-400 rounded-full"
          initial={{
            opacity: 0,
            scale: 0.5,
            x: Math.random() * 200 - 100,
            y: Math.random() * 100 - 50,
          }}
          animate={{
            opacity: [0, 1, 0],
            scale: [0.5, 1, 0.5],
            x: Math.random() * 200 - 100,
            y: Math.random() * 100 - 50,
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            delay: Math.random() * 1,
          }}
        />
      ))}
    </div>
  );
};
